import { ENVIRONMENT } from "@/constants/constants";
import { cn } from "@/helper/helper";
import { useAppSelector } from "@/hooks/useAppSelector";

type Props = {
  isWithinHousehold?: boolean;
  className?: string;
};

const AppVersion = ({ isWithinHousehold = false, className }: Props) => {
  const { version } = useAppSelector((state) => state.system);

  return (
    <div
      className={cn(
        `fixed ${isWithinHousehold ? "bottom-[52px]" : "bottom-0"}`,
        "rounded-tl-md bg-primary p-1 text-[8px] text-white print:hidden",
        `right-0 flex gap-2`,
        className
      )}
    >
      <span>UI v{APP_VERSION}</span>
      <span>API v{version}</span>
      <span>{ENVIRONMENT}</span>
    </div>
  );
};

export default AppVersion;
